/**
 * @generated SignedSource<<2887c62c09d315cd8a7ebb902e7c8c62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "intercomUserIdentity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pictureURL",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WelcomeModalQuery",
    "selections": (v0/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WelcomeModalQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "cbff421c06c2fc81eb1f16e6eff0b7ea",
    "id": null,
    "metadata": {},
    "name": "WelcomeModalQuery",
    "operationKind": "query",
    "text": "query WelcomeModalQuery {\n  user {\n    id\n    rowId\n    firstName\n    lastName\n    email\n    intercomUserIdentity\n    pictureURL\n  }\n}\n"
  }
};
})();

node.hash = "56d1a140e23631d2197b82a4a9953ba5";

module.exports = node;
